import React, { FC } from "react";
import {
  ActionGroup,
  ActionListItem,
  hasItemsSelected,
  ItemVariant,
  resolveActionGroupPreferences,
  SelectableAction,
  useResolveActionGroupColors,
} from "shared-ts-ui-action";
import { Layout } from "../../../Layout";
import ExpandMoreIcon from "@mui/icons-material/ExpandMoreRounded";
import ExpandLessRounded from "@mui/icons-material/ExpandLessRounded";
import { LayoutDirection } from "../../../LayoutDirection";

export interface GroupNodeProps {
  variant?: ItemVariant;
  layout: Layout;
  layoutDirection?: LayoutDirection;
  item: ActionGroup;
  open: boolean;
  hideLabel?: boolean;
  hasSiblings: boolean;
  onClick: () => void;
}

export const GroupNode: FC<GroupNodeProps> = (props) => {
  const { variant, layout, layoutDirection, item, hideLabel, onClick } = props;
  const preferences = resolveActionGroupPreferences(item.preferences, layout);
  const hideGroupNodeSelected = preferences?.hideGroupNodeSelected ?? false;
  const hasChildSelected = hasItemsSelected(item);
  const actionItem = {
    type: "Action",
    selectable: true,
    selected: true,
    name: item.name ?? "",
    nameBreakable: item.nameBreakable,
    icon: item.icon,
    onExecute: onClick,
  } as SelectableAction;

  const actionGroupColors = useResolveActionGroupColors();

  return (
    <ActionListItem
      variant={variant}
      item={actionItem}
      layout={layout}
      layoutDirection={layoutDirection}
      hideSelectionIcon={true}
      hideLabel={hideLabel}
      endAdornment={props.open ? <ExpandLessRounded /> : <ExpandMoreIcon />}
      sx={{
        backgroundColor: props.open ? actionGroupColors.selected : undefined,
        "&.direction-column": {
          "&.layout-medium": {
            borderRadius: 3,
            borderBottomLeftRadius: props.hasSiblings ? 0 : undefined,
            borderBottomRightRadius: props.hasSiblings ? 0 : undefined,
          },
        },
        "&&.selected": {
          ".MuiListItemButton-root": {
            color: hasChildSelected
              ? actionGroupColors.selectedText
              : undefined,
            backgroundColor:
              hasChildSelected && !hideGroupNodeSelected
                ? actionGroupColors.selected
                : "unset",
            ".MuiListItemIcon-root": {
              color: hasChildSelected
                ? actionGroupColors.selectedText
                : undefined,
              backgroundColor:
                hasChildSelected && !hideGroupNodeSelected
                  ? actionGroupColors.selected
                  : "unset",
            },
          },
          ".MuiListItemButton-root:hover": {
            backgroundColor: actionGroupColors.hover,
            color: actionGroupColors.selectedText,
          },
        },
        "&:hover": {
          backgroundColor: actionGroupColors.hover,
          color: actionGroupColors.selectedText,
        },
      }}
    />
  );
};
